module.exports = __webpack_public_path__ + "img/fail_icon.346addad.png";